import { render } from "./LevelScale.vue?vue&type=template&id=46eb3606&scoped=true"
import script from "./LevelScale.vue?vue&type=script&lang=js"
export * from "./LevelScale.vue?vue&type=script&lang=js"

import "./LevelScale.vue?vue&type=style&index=0&id=46eb3606&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46eb3606"]])

export default __exports__